// Pure display formatting shared by every chart primitive.

const COMPACT = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

/** Stat-tile / chart value: grouped digits below 10,000 (1,284), compact above
 *  (12.9K). The house rule for any large count read at a glance. */
export function formatCompactCount(value: number): string {
  if (!Number.isFinite(value)) return "-";
  return Math.abs(value) < 10_000 ? value.toLocaleString("en") : COMPACT.format(value);
}

/** A whole-dollar total ("$8,412", "$12.9K", "$1.4M"). Follows
 *  formatCompactCount's house rule rather than printing cents: a chart is read
 *  from a distance, and an ungrouped six-digit figure is unreadable at that
 *  range. Rounds rather than truncating, so a total never reads lower than it is. */
export function formatUsdTotal(value: number): string {
  if (!Number.isFinite(value)) return "-";
  return `$${formatCompactCount(Math.round(value))}`;
}

/** Default BucketFormatter: an ISO minute/hour string -> a clock-time label
 *  ("14:32"). Charts fed non-time bucket labels (a category, a day name)
 *  should pass their own formatter instead — this returns an empty string for
 *  anything that doesn't parse as a date, never a garbled fallback. */
export function formatBucketTime(bucket: string): string {
  const d = new Date(bucket);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}
